import {createSelector} from 'reselect';
import getAppliedGiftcards from '../GiftCardSelectors/getAppliedGiftcards';

export default createSelector(
  [getAppliedGiftcards],
  (appliedGiftcards) => {
    const giftCardsList = [];
    appliedGiftcards.forEach((giftcard) => {
      giftCardsList.push({
        cardNumber: giftcard.cardNumber,
        cardPin: giftcard.cardPin,
        uuid: giftcard.cardUUID,
        amountApplied: giftcard.amountApplied.value,
        paymentMethod: giftcard.paymentMethod,
      });
    });
    return giftCardsList;
  },
);
